import { autoinject, bindable, observable } from 'aurelia-framework';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { ForeignObjectTypeServiceService } from 'services/foreign-object-type-service-service';
import { ToastService } from 'services/toast-service';

type Model = {
  ForeignObjectTypeServiceId: number;
  Comment: string;
  Quantity: number;
  Id?: number;
};

type data = { data: ForeignObjectModel };

export type ForeignObjectModel = {
  ServiceId: number;
  ForeignObjectTypeServiceId: number;
  Comment: string;
  Quantity: number;
  Id?: number;
};

@autoinject
export class ForeignObjectCreateEdit {
  @bindable
  @observable
  model: Model;
  targetModel: Model = {
    ForeignObjectTypeServiceId: 0,
    Comment: '',
    Quantity: undefined,
  };
  modelChanged(model: Model) {
    this.targetModel = JSON.parse(JSON.stringify(model));

    this.form.ForeignObjectTypeServiceId = this.targetModel.ForeignObjectTypeServiceId;
    this.form.Comment = this.targetModel.Comment;
    this.form.Quantity = this.targetModel.Quantity;
  }

  @bindable service: Models.Service;

  @bindable onSave: (data: data) => void;
  @bindable onCanceled: () => void;

  @bindable
  @observable
  visible = false;

  protected form = {
    ForeignObjectTypeServiceId: undefined,
    Comment: undefined,
    Quantity: undefined,
  };

  constructor(
    private errorService: ErrorService,
    private foreignObjectTypeServiceService: ForeignObjectTypeServiceService,
    private toastService: ToastService
  ) {}

  protected async getForeignObjectTypeServices() {
    if (this.service.IsInvoicingCompatible) {
      const response = await this.foreignObjectTypeServiceService.getInvoiceableForeignObjectTypeServices(
        this.service.ServiceStation.ErpSystemId
      );
      const foreignObjectTypeServices = response.data;

      if (this.form.ForeignObjectTypeServiceId === 4) {
        foreignObjectTypeServices.push({
          Id: 4,
          Name: 'Andre fremmedlegemer',
          NameEn: 'Other foreign objects',
          NameEs: 'Other foreign objects',
          IsDeleted: false,
          Product: undefined,
        });
      }

      if (this.form.ForeignObjectTypeServiceId === 5) {
        foreignObjectTypeServices.push({
          Id: 5,
          Name: 'Dødfisk',
          NameEn: 'Dead fish',
          NameEs: 'Dead fish',
          IsDeleted: false,
          Product: undefined,
        });
      }

      if (this.form.ForeignObjectTypeServiceId === 6) {
        foreignObjectTypeServices.push({
          Id: 6,
          Name: 'Opphalertau',
          NameEn: 'Opphalertau',
          NameEs: 'Opphalertau',
          IsDeleted: false,
          Product: undefined,
        });
      }

      return foreignObjectTypeServices;
    } else {
      const response = await this.foreignObjectTypeServiceService.getStandardForeignObjectTypeServices();
      return response.data;
    }
  }

  private createModel() {
    const source = this.targetModel;
    const model = {
      ServiceId: this.service.Id,
      ForeignObjectTypeServiceId: this.form.ForeignObjectTypeServiceId,
      Comment: this.form.Comment,
      Quantity: this.form.Quantity,
    };

    if (source.Id) {
      model['Id'] = source.Id;
    }

    return model as ForeignObjectModel;
  }

  save() {
    if (!this.form.ForeignObjectTypeServiceId) {
      return this.toastService.showWarning('service.foreignObjectTypeErrorMsg');
    }

    try {
      this.onSave?.({
        data: this.createModel(),
      });
      this.resetForm();
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  resetForm() {
    this.form.ForeignObjectTypeServiceId = 0;
    this.form.Comment = undefined;
    this.form.Quantity = undefined;
  }

  cancel() {
    this.onCanceled?.();
  }
}
